import * as React from "react";
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid-pro";
import NumberField from "@AMIEWEB/Common/NumberField/NumberField";

function PercentEditCell(props: GridRenderEditCellParams) {
  const apiRef = useGridApiContext();          
  const { id, field, value } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value;

    // allow empty while typing; enforce up to 2 decimals and <= 100
    if (next === "" || (/^\d{0,3}(\.\d{0,2})?$/.test(next) && Number(next) <= 100)) {
      apiRef.current.setEditCellValue({
        id,
        field,
        value: next ? Number(next) : null,
      });
    }
  };

  return (
    <NumberField
      autoFocus
      value={value ?? ""}
      onChange={handleChange}
    />
  );
}

export const renderEditMarginCell = (params: GridRenderEditCellParams) => (
  <PercentEditCell {...params} />
);
